/**
 * Supported games/sports – same interface and features per game.
 * Used for header dropdown and filtering tournaments/matches.
 * Covers: Badminton, Cricket, Football, Table Tennis, Pickleball, Volleyball,
 * Basketball, Swimming, Tennis, Yoga, Gym, Squash, Shooting, Archery,
 * Running, Walking, Athletics, Kabaddi, Kho-Kho, Roller Skating.
 */
export const GAMES = [
  {
    id: 'table-tennis',
    name: 'Table Tennis',
    slug: 'table-tennis',
    icon: '🏓',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 11, gamesToWin: 3, maxGames: 5 },
  },
  {
    id: 'pickleball',
    name: 'Pickleball',
    slug: 'pickleball',
    icon: '🥒',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 11, gamesToWin: 2, maxGames: 3 },
  },
  {
    id: 'badminton',
    name: 'Badminton',
    slug: 'badminton',
    icon: '🏸',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 21, gamesToWin: 2, maxGames: 3 },
  },
  {
    id: 'football',
    name: 'Football',
    slug: 'football',
    icon: '⚽',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Goal',
    pointLabelPlural: 'Goals',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'cricket',
    name: 'Cricket',
    slug: 'cricket',
    icon: '🏏',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Run',
    pointLabelPlural: 'Runs',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'volleyball',
    name: 'Volleyball',
    slug: 'volleyball',
    icon: '🏐',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 25, gamesToWin: 2, maxGames: 3 },
  },
  {
    id: 'basketball',
    name: 'Basketball',
    slug: 'basketball',
    icon: '🏀',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'tennis',
    name: 'Tennis',
    slug: 'tennis',
    icon: '🎾',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 4, gamesToWin: 2, maxGames: 3 },
  },
  {
    id: 'swimming',
    name: 'Swimming',
    slug: 'swimming',
    icon: '🏊',
    matchLabel: 'Event',
    matchLabelPlural: 'Events',
    pointLabel: 'Lap',
    pointLabelPlural: 'Laps',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'squash',
    name: 'Squash',
    slug: 'squash',
    icon: '🎾',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 11, gamesToWin: 2, maxGames: 3 },
  },
  {
    id: 'shooting',
    name: 'Shooting',
    slug: 'shooting',
    icon: '🎯',
    matchLabel: 'Round',
    matchLabelPlural: 'Rounds',
    pointLabel: 'Score',
    pointLabelPlural: 'Scores',
    defaultScoring: { pointsToWin: 10, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'archery',
    name: 'Archery',
    slug: 'archery',
    icon: '🏹',
    matchLabel: 'Round',
    matchLabelPlural: 'Rounds',
    pointLabel: 'Score',
    pointLabelPlural: 'Scores',
    defaultScoring: { pointsToWin: 10, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'athletics',
    name: 'Athletics',
    slug: 'athletics',
    icon: '🏃',
    matchLabel: 'Event',
    matchLabelPlural: 'Events',
    pointLabel: 'Result',
    pointLabelPlural: 'Results',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'running',
    name: 'Running',
    slug: 'running',
    icon: '🏃',
    matchLabel: 'Run',
    matchLabelPlural: 'Runs',
    pointLabel: 'Distance',
    pointLabelPlural: 'Distances',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'walking',
    name: 'Walking',
    slug: 'walking',
    icon: '🚶',
    matchLabel: 'Session',
    matchLabelPlural: 'Sessions',
    pointLabel: 'Distance',
    pointLabelPlural: 'Distances',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'yoga',
    name: 'Yoga',
    slug: 'yoga',
    icon: '🧘',
    matchLabel: 'Session',
    matchLabelPlural: 'Sessions',
    pointLabel: '—',
    pointLabelPlural: '—',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'gym',
    name: 'Gym',
    slug: 'gym',
    icon: '💪',
    matchLabel: 'Session',
    matchLabelPlural: 'Sessions',
    pointLabel: '—',
    pointLabelPlural: '—',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'kabaddi',
    name: 'Kabaddi',
    slug: 'kabaddi',
    icon: '🤼',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'kho-kho',
    name: 'Kho-Kho',
    slug: 'kho-kho',
    icon: '🏃',
    matchLabel: 'Match',
    matchLabelPlural: 'Matches',
    pointLabel: 'Point',
    pointLabelPlural: 'Points',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
  {
    id: 'roller-skating',
    name: 'Roller Skating',
    slug: 'roller-skating',
    icon: '🛼',
    matchLabel: 'Session',
    matchLabelPlural: 'Sessions',
    pointLabel: '—',
    pointLabelPlural: '—',
    defaultScoring: { pointsToWin: 1, gamesToWin: 1, maxGames: 1 },
  },
];

export const DEFAULT_GAME_ID = 'table-tennis';

export function getGameById(id) {
  return GAMES.find((g) => g.id === id) || GAMES.find((g) => g.id === DEFAULT_GAME_ID);
}

export function getGameBySlug(slug) {
  return GAMES.find((g) => g.slug === slug) || getGameById(DEFAULT_GAME_ID);
}
